import React, { useState, useEffect } from "react";
import "./VendorList.css";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
};

const tableHeaderStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "rgb(230 109 51)",
    color: "white",
};

const tableCellStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    verticalAlign: "middle",
};

const filterButtonStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 15px",
    cursor: "pointer",
};

const filterSelectStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 10px",
};


// ✅ Helper: Format Date
const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

// ✅ Helper: Format Date + Time
const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
};

// ✅ Helper: Status
const getStatus = (endDate) => {
    if (!endDate) return "Unknown";
    const today = new Date();
    const end = new Date(endDate);
    return end >= today ? "Active" : "Expired";
};

const Topratingsfood = () => {
    const [data, setData] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [loading, setLoading] = useState(true);
    const { showLoader, hideLoader } = useLoader();
    // ✅ Fetch Data
    useEffect(() => {
        const fetchVendors = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                const response = await fetch(
                    "https://backend.maamaas.com/food/api/admin/toprated/paid",
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch vendor data");
                }

                const result = await response.json();
                setData(result);
            } catch (error) {
                console.error("Error fetching vendors:", error);
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchVendors();
    }, []);

    // ✅ Apply Date Filter
    const filteredData = data.filter((item) => {
        if (!selectedDate) return true; // no filter
        const orderDate = new Date(item.startDate);
        const filterDate = new Date(selectedDate);
        return (
            orderDate.getDate() === filterDate.getDate() &&
            orderDate.getMonth() === filterDate.getMonth() &&
            orderDate.getFullYear() === filterDate.getFullYear()
        );
    });

    // ✅ Export Function
    const handleExport = () => {
        if (filteredData.length === 0) {
            alert("No data to export for the selected date.");
            return;
        }

        const headers = [
            "S.No",
            "Vendor ID",
            "Offer Name",
            "Start Date",
            "End Date",
            "Amount Paid",
            "Payment Mode",
            "Purchased On",
            "Transaction ID",
            "Status",
        ];

        const csvRows = filteredData.map((item, index) => [
            index + 1,
            item.vendorId || "N/A",
            item.description || "N/A",
            formatDate(item.startDate),
            formatDate(item.endDate),
            item.amount ? `₹${item.amount}` : "N/A",
            item.paymentStatus || "N/A",
            formatDateTime(item.startDate),
            item.transactionId || "N/A",
            getStatus(item.endDate),
        ]);

        const csvString = [
            headers.join(","),
            ...csvRows.map((row) => row.join(",")),
        ].join("\r\n");

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "vendor_coupon_data.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <div style={{ height: "100vh", overflowY: "auto", marginTop: '10px' }}>
            {/* ✅ Date Picker + Export Button */}
            <div
                className="d-flex flex-wrap align-items-center mb-3 "
                style={{ gap: "10px" }}
            >
                <div>
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        style={filterSelectStyle}
                    />
                </div>

                <div style={{ marginLeft: "auto" }}>
                    <button onClick={handleExport} style={filterButtonStyle}>
                        Export CSV
                    </button>
                </div>
            </div>

            {/* ✅ Table */}
            {loading ? (
                <p>Loading vendor data...</p>
            ) : (
                <div className="ooo">
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={tableHeaderStyle}>S.No</th>
                                <th style={tableHeaderStyle}>Vendor ID</th>
                                <th style={tableHeaderStyle}>Offer Name</th>
                                <th style={tableHeaderStyle}>Start Date</th>
                                <th style={tableHeaderStyle}>End Date</th>
                                <th style={tableHeaderStyle}>Amount Paid</th>
                                <th style={tableHeaderStyle}>Payment Mode</th>
                                <th style={tableHeaderStyle}>Purchased On</th>
                                <th style={tableHeaderStyle}>Transaction ID</th>
                                <th style={tableHeaderStyle}>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((entry, index) => (
                                    <tr key={index}>
                                        <td style={tableCellStyle}>{index + 1}</td>
                                        <td style={tableCellStyle}>{entry.vendorId}</td>
                                        <td style={tableCellStyle}>{entry.description}</td>
                                        <td style={tableCellStyle}>{formatDate(entry.startDate)}</td>
                                        <td style={tableCellStyle}>{formatDate(entry.endDate)}</td>
                                        <td style={tableCellStyle}>₹{entry.amount}</td>
                                        <td style={tableCellStyle}>{entry.paymentStatus}</td>
                                        <td style={tableCellStyle}>
                                            {formatDateTime(entry.startDate)}
                                        </td>
                                        <td style={tableCellStyle}>{entry.transactionId}</td>
                                        <td
                                            style={{
                                                ...tableCellStyle,
                                                color:
                                                    getStatus(entry.endDate) === "Active"
                                                        ? "green"
                                                        : "red",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {getStatus(entry.endDate)}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" style={tableCellStyle}>
                                        No records found for selected date.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Topratingsfood;
